import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export interface AppEvent {
  name: string;
  content: any;
}

@Injectable({ providedIn: 'root' })
export class AppEventService {
  private eventSubject = new Subject<AppEvent>();

  broadcast(event: AppEvent): void {
    this.eventSubject.next(event);
  }

  subscribe(eventName: string): Observable<any> {
    return this.eventSubject.asObservable().pipe(
      filter(event => event.name === eventName),
      map(event => event.content)
    );
  }
}
